export default "__VITE_ASSET__65cd0613__"